import { Injectable, computed } from '@angular/core';

import { Observable, from } from 'rxjs';

import { BasicObjectSMI, Concesionario } from '@interfaces/index';
import { ConsumirApi } from '@utils/index';

@Injectable({
  providedIn: 'root'
})
export class ConcesionarioService {

  private controlador = computed(() => 'concesionario');
  private api = new ConsumirApi(this.controlador());

  constructor() {}

  public obtenerTodos(idEmpresa:number):Observable<BasicObjectSMI[]>{
    return from(this.api.get<BasicObjectSMI[]>(`${idEmpresa}`));
    // return this.http.get<coleccionDTO[]>(`${this.apiURL}/${idEmpresa}`);
  }

  public obtenerPorId(idEmpresa:number, id: number): Observable<Concesionario>{
    return from(this.api.get<Concesionario>(`${idEmpresa}/${id}`));
    // return this.http.get<concesionarioDTO>(`${this.apiURL}/${idEmpresa}/${id}`);
  }

  public crear(registro:Concesionario){
    return from(this.api.post<Concesionario, boolean>(``,registro));
    // return this.http.post(this.apiURL, registro);
  }

  public validarNombre(registro:Concesionario){
    return from(this.api.post<Concesionario, boolean>(`validarNombre`,registro));
    // return this.http.post(`${this.apiURL}/validarNombre`, registro);
  }

  public editar(id: number, registro:Concesionario){
    return from(this.api.put<Concesionario, boolean>(`${id}`,registro));
    // return this.http.put(`${this.apiURL}/${id}`, registro);
  }

  public borrar(id:number){
    return from(this.api.delete(`${id}`));
    // return this.http.delete(`${this.apiURL}/${id}`);
  }
}
